export { default } from 'features/store/components/store-info-modal';
